import React from 'react';
import classnames from 'classnames/bind';

import styles from './ideaViewSummaryStyles';

const cx = classnames.bind(styles);

const IdeaViewSummary = ({ view, fullText, isBig, viewerCanReceiveIntroRequest }) => {
  const { viewerCityName, viewerTitle, viewerAumRange, viewerFundType, ideaAssetSymbol } = view;
  const inflectionSubject = viewerCityName || viewerTitle || 'Member';
  const indefiniteArticle = inflectionSubject.charAt(0).match(/a|e|i|o|u/i) ? 'An' : 'A';
  const showAumAndFund =
    viewerCanReceiveIntroRequest && viewerAumRange && viewerAumRange !== 'N/A' && viewerFundType;
  return (
    <div className={cx({ viewSummary: true, isBig })}>
      {indefiniteArticle} {viewerCityName && <strong>{viewerCityName}-based </strong>}
      <strong>{viewerTitle && viewerTitle !== 'Other' ? viewerTitle : 'Member'}</strong>
      {showAumAndFund ? ` at a ${viewerAumRange} ${viewerFundType} ` : ' '}
      {fullText && (
        <span>
          viewed your idea for <strong>{ideaAssetSymbol}</strong>
        </span>
      )}
    </div>
  );
};

export default IdeaViewSummary;
